/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Camecount1Inputs */

const de__field_camecount1 = /** @type {(inputs: _Field_Camecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Teilnahmen`)
};

/**

* @param {_Field_Camecount1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_camecount1 = /** @type {((inputs?: _Field_Camecount1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Camecount1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_camecount1(inputs)
});
export { _field_camecount1 as "_field_cameCount" }